export const langDirection = (currentLang: string) => {
    const rtlLangs = [ "he" ]
    if(rtlLangs.includes(currentLang)){
        return "rtl"
    }
    return "ltr"
}